
<div class="add-custom-track">
  <div class="row-group">
    <div class="dialog-header">
      <div class="add-your-annotation">Add your annotation track</div>
      <img class="row-child" alt="" src="assets/img/toastclose.svg" width="16" (click)="onClose()" />
    </div>
    <div class="dialog-body">
      <div class="track-one">
        <div class="text-field">
          <div class="model-coordinates">Track name</div>
          <div class="description">e.g. My track, Important residues</div>
          <div class="text-field-inner">
            <input class="vf-form__input input-text" [ngClass]="{ 'input-error': trackNameError }" type="text" name="trackName" [(ngModel)]="trackName" value="" placeholder="Track 1" />
            <!-- <div class="input-text-wrapper"></div> -->

          </div>
          @if (trackNameError) {
            <p class="error-message">{{ trackNameError }}</p>
          }
        </div>
        <div class="text-field">
          <div class="model-coordinates">Residues or ranges</div>
          <div class="description">e.g. 1, 56, 24-52, 367-458</div>
          <div class="text-field-inner">
            <input class="vf-form__input input-text" [ngClass]="{ 'input-error': residueRangesErrors.length > 0 }" type="text" name="residueRanges" [(ngModel)]="residueRanges" (input)="onResidueRangesInput()" value="" placeholder="367-458" />
            <!-- <div class="input-text-wrapper"> </div> -->
          </div>
          @if (residueRangesErrors.length > 0) {
            <p class="error-message">{{ residueRangesErrors[0] }}</p>
          }
        </div>
      </div>
      <div class="we-do-not">We do not store this data. This data is kept only in the browser and will be deleted when you close the tab. </div>
    </div>
    <div class="dialog-footer">
      <div class="button-wrapper" id="frameContainer">
        <a class="button-primary vf-button vf-button--primary vf-button--sm" (click)="addTrack()">Add track</a>
      </div>
    </div>
  </div>
</div>


